export default "/images/a937ffc56ad0213a273fdb4a1da0a297.avif";